import { render, staticRenderFns } from "./CreateAlias.vue?vue&type=template&id=4ba9315a&"
import script from "./CreateAlias.vue?vue&type=script&lang=js&"
export * from "./CreateAlias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports